import { TextInput } from '../../../components/TextInput';
import { displayVatToolTip, setCompanyInfoField, TaxEntityType, touchCompanyInfoField } from '../companyInfoSlice';
import { useAppDispatch, useAppSelector } from '../../../configuration/setup/hooks';

interface VatFieldProps {
    validator(vat: string, taxEntity?: TaxEntityType): string | string[] | null;
    vatLabel: string;
    required: boolean;
    showPopoverIcon: boolean;
    className?: string;
    disabled?: boolean;
    requireTaxEntitySelection?: boolean;
}

export const VatField = (props: VatFieldProps) => {
    const vat = useAppSelector(state => state.companyInfo.vat);
    const vatTouched = useAppSelector(state => state.companyInfo.vatTouched);
    const entityType = useAppSelector(state => state.companyInfo.taxEntity);
    const showVatPopover = useAppSelector(state =>
        state.companyInfo.vatTooltipDisplayed === undefined ? false : state.companyInfo.vatTooltipDisplayed
    );
    const fieldName = 'companyVat';
    const dispatch = useAppDispatch();
    const placeholder =
        entityType === TaxEntityType.LegalEntity
            ? '12.345.678/0001-90'
            : entityType === TaxEntityType.NaturalEntity
              ? '123.456.789-01'
              : undefined;
    const label =
        entityType === TaxEntityType.LegalEntity
            ? 'CNPJ'
            : entityType === TaxEntityType.NaturalEntity
              ? 'CPF'
              : props.vatLabel;

    const validator = props.validator(vat, entityType);
    const isTaxEntitySelectionMissing =
        props.requireTaxEntitySelection &&
        entityType !== TaxEntityType.LegalEntity &&
        entityType !== TaxEntityType.NaturalEntity;
    const taxEntitySelectionTooltip = isTaxEntitySelectionMissing
        ? 'registration.companyData.cnpjcpf.selectTaxEntityHint'
        : undefined;

    return (
        <TextInput
            className={props.className ? `col-xs-12 col-sm-6 ${props.className}` : 'col-xs-12 col-sm-6'}
            disabled={props.disabled || isTaxEntitySelectionMissing}
            value={vat}
            label={label}
            placeholder={placeholder}
            tooltip={props.showPopoverIcon}
            required={props.required}
            name={fieldName}
            onTooltipClick={() => dispatch(displayVatToolTip(!showVatPopover))}
            // biome-ignore lint/suspicious/noExplicitAny: suppress out of convenience during migration to biome
            onChange={(evt: any) => dispatch(setCompanyInfoField({ fieldName: 'vat', value: evt.target.value }))}
            onBlur={() => dispatch(touchCompanyInfoField('vat'))}
            error={vatTouched ? (validator ? validator : undefined) : undefined}
            title={taxEntitySelectionTooltip}
        />
    );
};
